import { RouteObject } from 'react-router';

import { CrmPage } from './pages/CrmPage';
import VisitorsFeature from './features/visitors';
import OrdersFeature from './features/orders';
import ExportsFeature from './features/exports';
import { MassBroadcastsModal } from './features/massBroadcasts/containers/MassBroadcastsModal';
import { MassBroadcastsCreate } from './features/massBroadcasts/containers/MassBroadcastsCreate';
import { MassBroadcastsEdit } from './features/massBroadcasts/containers/MassBroadcastsEdit';
import { MassBroadcastsContainer } from './features/massBroadcasts/containers/MassBroadcastsContainer';
import { AutoBroadcastsContainer } from './features/autoBroadcasts/containers/AutoBroadcastsContainer';
import { AutoBroadcastModal } from './features/autoBroadcasts/containers/AutoBroadcastModal';
import { AutoBroadcastEdit } from './features/autoBroadcasts/containers/AutoBroadcastEdit';
import { AutoBroadcastDropCartContainer } from './features/autoBroadcasts/containers/AutoBroadcastDropCartContainer';
import { AutoBroadcastDropSessionContainer } from './features/autoBroadcasts/containers/AutoBroadcastDropSessionContainer';

const routes: RouteObject[] = [
    {
        path: 'crm',
        element: <CrmPage />,
        children: [
            ...VisitorsFeature.routes,
            ...OrdersFeature.routes,
            {
                path: 'mass-broadcasts',
                element: <MassBroadcastsContainer />,
                children: [
                    {
                        path: ':broadcastId',
                        element: <MassBroadcastsModal />,
                    },
                ],
            },
            {
                path: 'auto-broadcasts',
                element: <AutoBroadcastsContainer />,
                children: [
                    {
                        path: ':broadcastId',
                        element: <AutoBroadcastModal />,
                    },
                ],
            },
            ...ExportsFeature.routes,
        ],
    },
    {
        path: 'crm/mass-broadcasts/:id/create',
        element: <MassBroadcastsCreate />,
    },
    {
        path: 'crm/mass-broadcasts/:id/edit/:broadcastId',
        element: <MassBroadcastsEdit />,
    },
    {
        path: 'crm/auto-broadcasts/:shop_id/settings',
        element: <AutoBroadcastEdit />,
        children: [
            {
                path: 'drop-cart',
                element: <AutoBroadcastDropCartContainer />,
            },
            {
                path: 'drop-session',
                element: <AutoBroadcastDropSessionContainer />,
            },
        ],
    },
];

export default routes;
